import React, { ChangeEvent, CSSProperties, FC } from 'react'
import { styled } from 'styled-components'

const StyledInput = styled.input`
  padding: 4px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.forecast.secondaryText};
  color: ${({ theme }) => theme.forecast.activeText};
  background-color: ${({ theme }) => theme.forecast.pageBackground1};
`

interface EditFeatureInputProps {
  id: string
  value: string | number
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  type?: string
  step?: number
  style?: CSSProperties
}

export const EditFeatureInput: FC<EditFeatureInputProps> = (props) => {
  return (
    <StyledInput
      id={props.id}
      value={props.value}
      type={props.type ?? ''}
      step={props.step ?? ''}
      onChange={(e) => props.onChange(e)}
      onMouseDown={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === 'Escape') {
          e.currentTarget.blur()
          e.stopPropagation()
        }
      }}
      style={props.style ?? {}}
    />
  )
}
